import React, {Component} from 'react';

class User extends Component{
    state ={id:"",
username:""}
    componentDidMount(){
      }

    render(){
        return       ( <div>
        <span>{this.props.id}</span>
        <span>{this.props.username}</span>
        </div> );
    }
}


export default User;


// WEBPACK FOOTER //
// src/components/User.js